import { useEffect, useMemo, useState } from 'react'
import { removeDevices, useGetBrand, useGetDeviceType, useGetPlace } from 'src/api/userInfo'
import LoadingContainer from "src/components/ui/loading/loading-container"
import { useDeviceManagement } from 'src/context/stores'
import { deviceStatusId, deviceStatusName } from 'src/shared/constants/deviceStatus'
import { Icon_Library } from 'src/utils/widgetLibrary/IconTemplates/Icon_library'
import { useSWRConfig } from 'swr'
import { Device_Icon } from '../icons'
import DeviceTable from './DeviceTable'
import SetupDevice from './setupDevice'
import DeviceInterface from '../interface'
import { set } from 'react-hook-form'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const DeviceDetails = ({deviceList, plantId, showData, isLoadingDeviceList, isErrorDeviceList}) => {
  const { t } = useTranslation("settings");
  
  const { mutate } = useSWRConfig()
  const { brandList } = useGetBrand()
  const { getDeviceType } = useGetDeviceType()
  const { getPlace:location } = useGetPlace(plantId, "deviceSetup")
  const [updateDeviceSetup,updateIsEditDevice] = useDeviceManagement((state) => [state.updateDeviceSetup, state.updateIsEditDevice])
  const [updateSelectionList, updateFieldProperties, resetAll] = useDeviceManagement((state) => [state.updateSelectionList, state.updateFieldProperties, state.resetAll])
  const [filteredDevices, setFilteredDevices] = useState([])
  const [selectedStatus, setSelectedStatus] = useState([])
  const [selectedMenu, setSelectedMenu] = useState('all')
  const [showSetup, setShowSetup] = useState(false)
  const [editDevice, setEditDevice] =useState({status: false, data: undefined});
  const [showEditPopup, setShowEditPopup] = useState(false)
  const [showInterface, setShowInterface] = useState(false)

    
  const deviceLocationLookup = useMemo(() => {
      const map = new Map();
      location?.forEach((building) => {
        building?.floor?.forEach((floor) => {
          floor?.place?.forEach((place) => {
            map?.set(place?.place_id, {
              building: building?.building_name,
              floor: floor?.floor_name,
              placeName: place?.place_name,
            });
          });
        });
      });
      return map;
    }, [deviceList]);



    
 useEffect(() => {
    setShowEditPopup(showSetup)
 }, [showSetup])

  useEffect(() => {
    if(deviceList){
        setFilteredDevices(deviceList?.devices)
    }

    return () => {
        setFilteredDevices([])
    }
  }, [deviceList])


  const handleSelectType = (status) => {
    setSelectedMenu(status)
    setSelectedStatus([])
    if (status === 'Others') {
      setFilteredDevices(
          deviceList?.devices.filter(
            (type) =>
              type.physical_type !== 'Solar' &&
              type.physical_type !== 'Bio gas' &&
              type.physical_type !== 'Battery' &&
              type.physical_type !== 'Wind Turbine'
          )
      )
    } else if (status !== 'all') {
      setFilteredDevices(deviceList?.devices?.filter((type) => type.physical_type === status))
    } else {
      setFilteredDevices(deviceList?.devices)
    }
  }

  const handleSelectStatus = (status) => {

    let filters =[]
    if (status !== 'all') {
      filters = selectedStatus.includes(status) ? selectedStatus.filter((x) => x !== status) : [...selectedStatus, status];
      
      setSelectedStatus(filters.length > 0 ? filters : []);
      if(filters.length > 0){
        setFilteredDevices(deviceList?.devices.filter(dev => filters.includes(deviceStatusName[dev.status]?.name)));
      }else{
        setFilteredDevices(deviceList?.devices)
        setSelectedStatus([])
      }
      
    }else{
      setFilteredDevices(deviceList?.devices)
      setSelectedStatus([])
    }
  }


  const removeDevice = (device)=>{
    try {
      const deviceRemoved =removeDevices(device.id)
      mutate(`/api/plant/${plantId}/device/`)
    } catch (error) {
      alert(error)
    }
  }

const openAddDevice= () => {
  const brand = brandList?.find((b) => b?.label.toLowerCase().includes('huawei'))
  updateSelectionList({
    buildingSelectionList:location,
    modelSelectionList:[],
    brands: brandList?.filter((brand)=> !brand.label.toLowerCase().includes('huawei')),
    huaweiModels: brand?.model?.map((m)=>({value: m.id, label: m.name}))
  })
    setShowSetup(true)
    setEditDevice({status: false, data: undefined})
}


const openEditDevice= (device) => { 
  const brand = brandList?.find((b)=>b?.label ==device?.brand)
  const model = brand?.model?.find((m)=>m.name ==device?.model)
  const physicalType = getDeviceType?.find((p_type)=>p_type.name ==device?.physical_type)
  let defaultDeviceType = ""
  let brands = brandList?.filter((brand)=> !brand.label.toLowerCase().includes('huawei'))

  
  
  if(device?.brand.toLowerCase().includes('huawei') && device?.config){
    defaultDeviceType = JSON.parse(device?.config)?.external_type?.code
  }
  const modelSelectionList = brand?.model?.map((m)=>({value: m.id, label: m.name}))

  if(device?.property && JSON.parse(device?.property)?.length > 0){
    updateFieldProperties(JSON.parse(device?.property))
  }

  updateSelectionList({
    buildingSelectionList:location,
    modelSelectionList:modelSelectionList,
    brands: brands,
  })
  // location
  updateDeviceSetup({
    ...device,
    model: model?.id,
    brand: brand?.id,
    physical_type: Number(physicalType?.id) || '',
    huawei_device_id: defaultDeviceType,
    devTypeId: defaultDeviceType
  })

  setShowSetup(true)
  updateIsEditDevice(true)
  
  setEditDevice({status: true, data: device})
}

const closeAddDevice= () => {
  resetAll()
  setShowSetup(false)
  console.clear()
}
 
  return (
    <LoadingContainer
    isLoading={isLoadingDeviceList}
    isError={isErrorDeviceList}
    hasData={deviceList?.devices?.length > 0}
    loadingText={`${t('device_management.loading.loading_device')}`}
    errorText={`${t('device_management.loading.error_device')}`}
    noDataText={`${t('device_management.loading.no_device')}`}
    >

      <div className="h-full overflow-x-auto overflow-y-hidden layout rounded-xl ">

        {/* Devices list */}
        {deviceList?.devices?.length === 0 && showData && filteredDevices?.length === 0 ? (
          <div className="grid gap-4 p-4 m-4 bg-white rounded-md shadow-xl md:grid-cols-4 lg:grid-cols-7 h-96">
            <h1 className="text-xl font-bold">{t('device_management.device_setup.device_list')}</h1>
            <div className="grid col-span-7 justify-items-center">
              <Device_Icon />
              <p className="w-full my-2 text-xl font-bold text-center text-primary">
                {t('device_management.loading.no_device')}
              </p>
              <p className="my-2 text-sm font-medium text-tertiary">
                {t('device_management.device_setup.text_selected_device')}
              </p>
              <button
                onClick={() => openAddDevice()}
                className="flex items-center gap-1 p-4 mt-4 text-sm font-semibold text-white rounded-lg bg-vekin"
              >
                <i className="ri-add-line"></i> {t('device_management.device_setup.add_device')}
              </button>
            </div>
          </div>
        ) : (
          <section className="h-full gap-4 p-4 m-4 bg-white rounded-md shadow-xl">
            <div className="flex flex-row items-center justify-between mb-4">
              <div className="grid md:col-span-3 lg:col-start-1 lg:col-end-6">
                <div className="flex items-center gap-8">
                  <h1 className="text-xl font-bold">{t('device_management.device_setup.device_list')}</h1>
                </div>
              </div>

              {showData && (
                <div className="flex justify-end gap-8">
                  <Link to={`/device-management/${plantId}/interface`} className="flex items-center gap-1 p-4 py-2.5 text-sm font-semibold text-vekin rounded-lg border border-vekin">
                  {t('device_management.interface')}
                  </Link>
               
                  
                  <button
                    type='button'
                    onClick={() => openAddDevice()}
                    className="flex items-center gap-1 p-4 py-2.5 text-sm font-semibold text-white rounded-lg bg-vekin"
                  >
                    <i className="ri-add-line"></i> {t('device_management.add_device')}
                  </button>
                </div>
              )}
            </div>

            {/* device status */}
            <div className="grid grid-flow-col gap-2 overflow-x-scroll ">
                {deviceList?.status_overview?.map((state) => (
                <div key={state.status} className="flex items-center justify-between w-48 h-20 p-4 border border-[#F1F3F5]">
                    <div>
                    <p className="text-sm font-medium capitalize">{state.status}</p>
                    <div className="flex items-center gap-2">
                        <p className="font-semibold text-vekin">{state.amt}</p>
                        <div className="text-sm font-medium text-tertiary">{t('device_management.device')} </div>
                    </div>
                    </div>
                    <div className="flex items-center justify-center w-10 h-10 rounded-full bg-vekin-green-50">
                    <div className='w-5 h-5 rounded-full' style={{backgroundColor: deviceStatusId[state?.status]?.color}}></div>
                    </div>
                </div>
                ))}
                {deviceList?.overview?.map((device_overview) => (
                <div
                    key={device_overview.device}
                    className="flex items-center justify-between w-48 h-20 p-4 border border-[#F1F3F5]"
                >
                    <div>
                    <p className="text-sm font-medium capitalize">{device_overview.device}</p>
                    <div className="flex items-end gap-2">
                        <p className="font-semibold text-vekin">{device_overview.amt}</p>
                        <p className="text-sm font-medium text-tertiary">{t('device_management.device')}</p>
                    </div>
                    </div>
                    {Icon_Library(
                    device_overview?.icon,
                    'w-10 h-10 bg-vekin-green-50 rounded-full '
                    )}
                </div>
                ))}
            </div>
               

            <div className="flex h-full gap-2 my-4 overflow-x-auto bg-white border rounded-md border-quartenary">
              <button
                type="button"
                onClick={() => handleSelectType('all')}
                className={`${
                  selectedMenu === 'all' ? 'bg-vekin/20' : 'bg-white'
                } px-4 py-2 h-full text-secondary text-xs font-medium`}
              >
                {t('device_management.status.all')}
              </button>
              {deviceList?.overview?.map(({ device }, index) => (
                <button
                  key={device}
                  type="button"
                  onClick={() => handleSelectType(device)}
                  className={`${
                    selectedMenu === device ? 'bg-vekin/20' : 'bg-white'
                  } px-4 py-2 h-full text-secondary text-xs font-medium`}
                >
                  {device}
                </button>
              ))}
            </div>

            <div className="flex h-full py-2 overflow-x-auto bg-white rounded-md">
              <div className="flex items-center gap-3 lg:flex-row ">
                <p className="text-sm font-medium text-secondary">{t('device_management.status.title')}:</p>
                <button
                  type="button"
                  onClick={() => {
                    setSelectedStatus([])
                    handleSelectStatus('all')
                  }}
                  className={
                    selectedStatus?.length === 0 ? 'status_primary_btn justify-center' : 'status_secondary_btn  justify-center'
                  }
                >
                  {t('device_management.status.all')}
                </button>
                {deviceList?.status_overview?.map(({ status }, index) => (
                  <button
                    type="button"
                    key={index+status}
                    onClick={() => handleSelectStatus(status)}
                    className={
                      selectedStatus.includes(status)
                        ? 'status_primary_btn min-w-[8rem] justify-center capitalize'
                        : 'status_secondary_btn min-w-[8rem] justify-center capitalize'
                    }
                  >
                    <div className='w-5 h-5 rounded-full shadow' style={{backgroundColor: deviceStatusId[status]?.color}}></div>
                    {status}
                  </button>
                ))}
              </div>
            </div>

            <div className="col-span-7 mt-4">
              {filteredDevices?.length === 0 ? (
                <div className="grid gap-4 p-4 m-4 bg-white rounded-md shadow-xl md:grid-cols-4 lg:grid-cols-7 h-96">
                  <div className="grid col-span-7 justify-items-center">
                    <Device_Icon />
                    <p className="w-full my-2 text-xl font-bold text-center text-primary">
                      {t('device_management.device_with_status')} :
                      {selectedStatus?.map((status) => (
                        <span className="capitalize " key={status}>{status} </span>
                      ))}
                      {t('device_management.not_found')}
                    </p>
                  </div>
                </div>
              ) : (
                <div className="relative overflow-x-auto overflow-y-auto bg-white rounded-lg shadow">
                  <DeviceTable
                  filteredDevices={filteredDevices}
                  showData={showData}
                  deviceLocationLookup={deviceLocationLookup}
                  openEditDevice={openEditDevice}
                  removeDevice={removeDevice}
                  />
               
                </div>
              )}
            </div>
          </section>
        )}



      {showEditPopup  && <SetupDevice
            isEditDevice={editDevice?.status}
            onClose={closeAddDevice}
            showSetup={showSetup}
            device={editDevice?.data} 
            plantLocation={{name:deviceList?.name, location:deviceList?.location}}
            plantId={plantId}
            />
       }

       {/* {showEditPopup && <DeviceInterface  handleClose={setShowInterface}/>} */}
      </div>
    </LoadingContainer>
  )
}

export default DeviceDetails
